<template>
  <div
    v-if="digitType.length >= 1"
    class="col-12 px-0"
  >
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), specialButtonDel()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form
      id="shoot"
      method="POST"
      class="w-100"
      @submit.prevent="onSubmit"
    >
      <div class="d-flex">
        <div class="flex-width">
          <div class="form-group">
            <input
              v-model="digitValue"
              required="required"
              name="digit"
              disabled="disabled"
              class="form-control text-center text-lg disabled"
              type="tel"
              :placeholder="placeHolder"
              :maxlength="digitValueSet"
              :minlength="digitValueSet"
              @keypress="validateNumber($event)"
              @paste="onPaste($event)"
            >
          </div>
        </div>
      </div>
      <div
        v-if="digitValueSet > 1"
        class="d-flex"
      >
        <button
          :class="{ active: shuffleDigit }"
          class="w-100 btn btn-outline-dark mb-1"
          @click="shuffleButton"
        >
          <i class="fas fa-random mr-2" /> สลับเลข
        </button>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(1)"
          >
            1
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(2)"
          >
            2
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(3)"
          >
            3
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(4)"
          >
            4
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(5)"
          >
            5
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(6)"
          >
            6
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(7)"
          >
            7
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(8)"
          >
            8
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(9)"
          >
            9
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-width my-1">
          <button
            type="reset"
            class="btn btn-dark w-100"
            @click="digitClear()"
          >
            ลบ
          </button>
        </div>
        <div class="flex-width mx-1 my-1">
          <button
            type="button"
            class="btn btn-yellow w-100"
            @click="digitClick(0)"
          >
            0
          </button>
        </div>
        <div class="flex-width my-1">
          <button
            type="submit"
            class="btn btn-dark w-100"
            @click="pushDigit"
          >
            เพิ่ม
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'PickDigit',
  props: {
    digitType: {
      type: Array,
      required: true,
    },
    lottoNumbersWithType: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog_message: '',
      dialog: false,
      delVal: '',
      digitValue: '',
      digitValueSet: 1,
      placeHolder: `กรอกเลข ${this.digitValueSet} หลัก`,
      shuffleDigit: false,
    };
  },
  computed: {},

  watch: {
    digitType() {
      if (
        this.digitType.indexOf('any_upper') != -1
        || this.digitType.indexOf('any_under') != -1
      ) {
        this.digitValue = '';
        this.digitValueSet = 1;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      } else if (
        this.digitType.indexOf('2upper') != -1
        || this.digitType.indexOf('2under') != -1
      ) {
        this.digitValue = '';
        this.digitValueSet = 2;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      } else {
        this.digitValue = '';
        this.digitValueSet = 3;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      }
    },
  },
  mounted() {
    this.startConvertType();
  },
  methods: {
    shuffleButton(evn) {
      this.shuffleDigit = !this.shuffleDigit;
    },
    digitClick(eValue) {
      if (this.digitValue.length < this.digitValueSet) {
        this.digitValue += eValue;
      } else {
        this.digitValue = '';
        this.digitValue += eValue;
      }
    },
    digitClear() {
      const val = this.digitValue;
      if (this.selectedDigit.indexOf(val) != -1) {
        delete this.selectedDigit[this.selectedDigit.indexOf(val)];
        this.$emit('child-digitClick', val);
      }
      this.digitValue = '';
    },
    onSubmit(e) {
      e.preventDefault();
    },
    onPaste(evt) {
      evt.preventDefault();
    },
    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    startConvertType() {
      if (
        this.digitType.indexOf('any_upper') != -1
        || this.digitType.indexOf('any_under') != -1
      ) {
        this.digitValue = '';
        this.digitValueSet = 1;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      } else if (
        this.digitType.indexOf('2upper') != -1
        || this.digitType.indexOf('2under') != -1
      ) {
        this.digitValue = '';
        this.digitValueSet = 2;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      } else {
        this.digitValue = '';
        this.digitValueSet = 3;
        this.placeHolder = `ระบุเลข ${this.digitValueSet} หลัก`;
      }
    },
    ShuffleDouble(val) {
      self = this;
      let valset;
      valset = val.toString();
      valset = valset.split('');
      valset = valset.reverse();
      valset = valset.join('');

      if (valset == val) {
        return false;
      }
      self.$emit('child-digitClick', valset.toString());
    },
    ShuffleTripple(val) {
      self = this;
      let valset;
      valset = val.toString();
      valset = valset.split('');

      let valtemp;

      if (valset[0] == valset[1] && valset[1] == valset[2]) {
        // self.$emit("child-digitClick", val);
      } else if (valset[0] == valset[1]) {
        for (let i = 1; i < 3; i++) {
          switch (i) {
            case 0:
              valtemp = valset[0] + valset[1] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 1:
              valtemp = valset[0] + valset[2] + valset[1];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 2:
              valtemp = valset[2] + valset[1] + valset[0];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            default:
          }
        }
      } else if (valset[0] == valset[2]) {
        for (let i = 1; i < 3; i++) {
          switch (i) {
            case 0:
              valtemp = valset[0] + valset[1] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 1:
              valtemp = valset[0] + valset[2] + valset[1];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 2:
              valtemp = valset[1] + valset[0] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            default:
          }
        }
      } else if (valset[1] == valset[2]) {
        for (let i = 1; i < 3; i++) {
          switch (i) {
            case 0:
              valtemp = valset[0] + valset[1] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 1:
              valtemp = valset[2] + valset[1] + valset[0];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 2:
              valtemp = valset[1] + valset[0] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            default:
          }
        }
      } else {
        for (let i = 1; i < 6; i++) {
          switch (i) {
            case 1:
              valtemp = valset[0] + valset[2] + valset[1];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 2:
              valtemp = valset[1] + valset[0] + valset[2];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 3:
              valtemp = valset[1] + valset[2] + valset[0];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 4:
              valtemp = valset[2] + valset[0] + valset[1];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            case 5:
              valtemp = valset[2] + valset[1] + valset[0];
              valtemp = valtemp.toString();
              self.$emit('child-digitClick', valtemp);
              break;
            default:
          }
        }
      }
    },
    specialButtonDel() {
      this.$emit('child-digitClick', this.delVal);

      if (this.digitValueSet == 2 && this.shuffleDigit) {
        this.ShuffleDouble(this.delVal);
      }
      if (this.digitValueSet == 3 && this.shuffleDigit) {
        this.ShuffleTripple(this.delVal);
      }
      this.digitValue = '';
    },
    pushDigit() {
      let countSearch = 0;
      const val = this.digitValue;
      if (val.length == this.digitValueSet) {
        if (this.digitType.length == 1) {
          const search1 = this.lottoNumbersWithType.filter(
            (item) => item.digits == val && item.type == this.digitType[0],
          );
          countSearch = search1.length;
        }
        if (this.digitType.length == 2) {
          const search1 = this.lottoNumbersWithType.filter(
            (item) => item.digits == val && item.type == this.digitType[0],
          );
          const search2 = this.lottoNumbersWithType.filter(
            (item) => item.digits == val && item.type == this.digitType[1],
          );

          countSearch = parseInt(search1.length) + parseInt(search2.length);
        }
        if (countSearch >= this.digitType.length) {
          this.$set(this, 'dialog', true);
          this.$set(this, 'dialog_message', `ต้องการลบเลข ${val}`);
          this.$set(this, 'delVal', val);
        } else {
          this.$emit('child-digitClick', val);
          if (this.digitValueSet == 2 && this.shuffleDigit) {
            this.ShuffleDouble(val);
          }
          if (this.digitValueSet == 3 && this.shuffleDigit) {
            this.ShuffleTripple(val);
          }

          Vue.$toast.open({
            message: `เพิ่มเลข ${val} สำเร็จ`,
            type: 'success',
            duration: 1000,
            position: 'top-right',
            dismissible: true,
          });

          this.digitValue = '';
        }
      }
    },
  },
};
</script>
